import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { ClubIntro } from "@/components/landing/ClubIntro";
import { PlantelTabs } from "@/components/landing/PlantelTabs";
import { ExploraHub } from "@/components/landing/ExploraHub";
import { TiendaMembresiasCTA } from "@/components/landing/TiendaMembresiasCTA";
import { FinalCTA, Footer } from "@/components/landing/FooterCTA";
import { BackToTop } from "@/components/landing/BackToTop";
import { SponsorHeroBadge, SponsorSpotlight } from "@/components/Sponsors";
import { SponsorSection } from "@/components/SponsorShowcase";

export default function Landing() {
  return (
    <div className="App min-h-screen bg-[#eef1f7]">
      <Navbar overHero />
      <main>
        <Hero />
        <SponsorHeroBadge />
        <ClubIntro />
        <PlantelTabs />
        <SponsorSpotlight preferCategory="Indumentaria" eyebrow="Indumentaria oficial del plantel" />
        <ExploraHub />
        <SponsorSpotlight preferCategory="Gastronomía" eyebrow="El tercer tiempo es con" />
        <SponsorSection placement="wall" ctaHref="/patrocinadores" />
        <TiendaMembresiasCTA />
        <FinalCTA />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}
